// client/src/pages/doctors/AssignTemplate.jsx
import React from 'react';
import AssignTemplateComponent from '../../components/doctors/FormBuilder/AssignTemplate';

const AssignTemplate = () => {
  return <AssignTemplateComponent />;
};

export default AssignTemplate;